export const ANALYTICS_OPT_OUT_STORAGE_KEY = 'trellis_analytics_opt_out'

export const ANALYTICS_NOTICE_DISMISSED_STORAGE_KEY = 'trellis_analytics_notice_dismissed'

export const GTM_SCRIPT_URL = 'https://www.googletagmanager.com/gtm.js'

export const GA_COOKIE_NAME_PATTERN = /^_ga(_.+)?$/

export const CONSENT_DENIED = {
  analytics_storage: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
} as const

export const CONSENT_ANALYTICS_GRANTED = { analytics_storage: 'granted' } as const

export const ANALYTICS_ONBOARDING_STEPS = [
  'terms',
  'welcome',
  'business',
  'tax',
  'branding',
  'payment',
  'congrats',
] as const

export const ANALYTICS_ENTITIES = [
  'client',
  'quote',
  'invoice',
  'recurring_invoice',
  'expense',
] as const

export const ANALYTICS_REPORT_TABS = [
  'overview',
  'revenue-clients',
  'expenses',
  'tax',
  'gst-bas',
  'profit-loss',
] as const

export type AnalyticsEntity = (typeof ANALYTICS_ENTITIES)[number]

export const ANALYTICS_DOCUMENT_ENTITIES = ['invoice', 'quote'] as const

export const ANALYTICS_USER_PROPERTY_NAMES = [
  'tenant_hash',
  'user_role',
  'deploy_env',
  'app_version',
] as const
